/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type removeAddOnMutationVariables = {
  subscriptionItemId: string;
};
export type removeAddOnMutationResponse = {
  readonly superposherRemoveAddOn: {
    readonly success: boolean;
  };
};
export type removeAddOnMutation = {
  readonly response: removeAddOnMutationResponse;
  readonly variables: removeAddOnMutationVariables;
};

/*
mutation removeAddOnMutation(
  $subscriptionItemId: String!
) {
  superposherRemoveAddOn(subscriptionItemId: $subscriptionItemId) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'subscriptionItemId',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'subscriptionItemId',
            variableName: 'subscriptionItemId',
          },
        ],
        concreteType: 'SuperposherRemoveAddOnResponseType',
        kind: 'LinkedField',
        name: 'superposherRemoveAddOn',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'removeAddOnMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'removeAddOnMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'ff17452ce70ea030b4fa83534f9fecac',
      id: null,
      metadata: {},
      name: 'removeAddOnMutation',
      operationKind: 'mutation',
      text: 'mutation removeAddOnMutation(\n  $subscriptionItemId: String!\n) {\n  superposherRemoveAddOn(subscriptionItemId: $subscriptionItemId) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'd6b49834c45b81d78fa6dffcb6e20301';
export default node;
